import { VerticalContainer } from '@/components';
import { format, R } from '@/features/profile/resources/ProfileResources.resx';
import { InsurancePartnerCard } from '@/features/profile/widgets/access/ui/InsurancePartnerCard';
import { MyServices } from '@/features/profile/widgets/access/ui/MyServices';
import {
    CouponRedemptionViewModel,
    SubscriptionDetailsResponse,
    TrainingProgramViewModel,
} from '@/features/profile/model/types';
import { CompanyAccessInfo } from '@/shared/interfaces';

type AccessProps = {
    companyAccessInfo: CompanyAccessInfo;
    couponRedemptions: CouponRedemptionViewModel[];
    trainingPrograms: TrainingProgramViewModel[];
    subscriptions: SubscriptionDetailsResponse[];
};

const getInsurancePartnerDescription = (
    accessInfo: CompanyAccessInfo,
): string => {
    if (accessInfo.HasAccessThroughHouseholdMember) {
        return format(
            R.ProfileInsuranceYouHaveAccessVia,
            accessInfo.AccessProvidingHouseholdMemberName ?? '',
        );
    }

    if (accessInfo.HasAdolescentAccess) {
        return format(
            R.ProfileInsuranceYouHaveAccessVia,
            accessInfo.AdolescentAccessOwnerName ?? '',
        );
    }

    const companyName = accessInfo.Company?.CompanyName;

    if (accessInfo.HasAccessThroughInsuranceProvider && companyName) {
        return format(R.ProfileInsuranceYouHaveAccessVia, companyName);
    }

    return R.Profile_Insurance_Intro_With_Email;
};

export const Access = ({
    companyAccessInfo,
    couponRedemptions,
    trainingPrograms,
    subscriptions,
}: AccessProps) => {
    const companyName = companyAccessInfo.Company?.CompanyName;

    const insurancePartnerDescription =
        getInsurancePartnerDescription(companyAccessInfo);

    const isAdolescentAccess = companyAccessInfo.HasAdolescentAccess;

    return (
        <VerticalContainer spacing="md">
            <h2 id="heading-Access">{R.Access}</h2>

            <div>
                <div className="max-w-prose leading-normal text-(--color-text-primary)">
                    {insurancePartnerDescription}
                </div>

                <VerticalContainer spacing="lg" className="mt-2 w-full">
                    {!isAdolescentAccess && (
                        <InsurancePartnerCard companyName={companyName} />
                    )}

                    <MyServices
                        couponRedemptions={couponRedemptions}
                        trainingPrograms={trainingPrograms}
                        subscriptions={subscriptions}
                    />
                </VerticalContainer>
            </div>
        </VerticalContainer>
    );
};
